import { render, staticRenderFns } from "./transaction.vue?vue&type=template&id=47184228&scoped=true&"
import script from "./transaction.vue?vue&type=script&lang=js&"
export * from "./transaction.vue?vue&type=script&lang=js&"
import style1 from "./transaction.vue?vue&type=style&index=1&id=47184228&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47184228",
  null
  
)

export default component.exports